// https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackSettings

import { isMobileSafari, isSafari } from 'react-device-detect'

import { userTypes } from 'constants/user'
import { isFunction } from 'helpers/miscellaneous'
import { videoConstraints } from 'helpers/twilio'
import { logger } from 'utils/logger'

const _isSafari = isSafari || isMobileSafari

const audio = (() => {
    let supportedConstraints = {}

    if (isFunction(navigator?.mediaDevices?.getSupportedConstraints)) {
        supportedConstraints = {
            ...navigator.mediaDevices.getSupportedConstraints(),
        }
    }

    logger.info({ supportedConstraints })

    let constraints = { name: `audio-${Date.now()}` }

    if (supportedConstraints.deviceId)
        constraints.deviceId = { exact: 'default' }

    if (supportedConstraints.channelCount)
        constraints.channelCount = { ideal: 2 } // 1 for mono, 2 for stereo, and so forth.

    if (supportedConstraints.autoGainControl)
        constraints.autoGainControl = { exact: true }

    if (supportedConstraints.echoCancellation)
        constraints.echoCancellation = { exact: true }

    if (supportedConstraints.noiseSuppression)
        constraints.noiseSuppression = { exact: true }

    if (supportedConstraints.sampleRate)
        constraints.sampleRate = { ideal: 44100 }

    if (supportedConstraints.sampleSize) constraints.sampleSize = { ideal: 16 }

    if (supportedConstraints.volume) constraints.volume = 1.0

    constraints.advanced = [
        { googExperimentalEchoCancellation: { exact: true } },
        { googHighpassFilter: { exact: true } },
        { googAudioMirroring: { exact: true } },
    ]

    return constraints
})()

const video = {
    name: `camera-${Date.now()}`,
}

const commonOptions = {
    facingMode: 'user',
}

const videoExtras = {
    ...commonOptions,
    width: { ideal: videoConstraints.default.width },
    height: { ideal: videoConstraints.default.height },
    frameRate: { ideal: videoConstraints.default.frameRate },
}

const teacherVideoExtras = {
    ...commonOptions,
    width: { ideal: videoConstraints.teacher.width },
    height: { ideal: videoConstraints.teacher.height },
    frameRate: { ideal: videoConstraints.teacher.frameRate },
}

export const constraints = userType => ({
    audio: _isSafari || audio,
    video: _isSafari
        ? video
        : {
              ...video,
              ...(userType === userTypes.TEACHER
                  ? teacherVideoExtras
                  : videoExtras),
          },
})
